import React from 'react';
export default function PromoteBadge({ name, image }) {
    const altText = `${name} available`;
    return React.createElement("img", { className: 'badge', src: image, alt: altText, title: altText });
}
